export default __webpack_public_path__ + "static/media/Send-gift-amico.b3e21c9b.svg";